// import React from "react";
import { useDocument } from "../../firebase-files/hooks/useDocument";

import {
  BarLoader,
  BounceLoader,
  CircleLoader,
  ClimbingBoxLoader,
  ClipLoader,
  ClockLoader,
  DotLoader,
  FadeLoader,
  GridLoader,
  HashLoader,
  MoonLoader,
  PacmanLoader,
  PropagateLoader,
  PuffLoader,
  PulseLoader,
  RingLoader,
  RiseLoader,
  RotateLoader,
  ScaleLoader,
  SkewLoader,
  SquareLoader,
  SyncLoader,
  BeatLoader,
} from "react-spinners";

const PGLoaders = () => {
  const { document: loaderTypeDoc, error: loaderTypeDocerror } = useDocument(
    "settings",
    "loaders"
  );
  return (
    <div className="d-flex align-items-center">
      {loaderTypeDoc && loaderTypeDoc.activeLoader === "BarLoader" ? (
        <BarLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "BounceLoader" ? (
        <BounceLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "CircleLoader" ? (
        <CircleLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "ClimbingBoxLoader" ? (
        <ClimbingBoxLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "ClipLoader" ? (
        <ClipLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "ClockLoader" ? (
        <ClockLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "DotLoader" ? (
        <DotLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "FadeLoader" ? (
        <FadeLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "GridLoader" ? (
        <GridLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "HashLoader" ? (
        <HashLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "MoonLoader" ? (
        <MoonLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "PacmanLoader" ? (
        <PacmanLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "PropagateLoader" ? (
        <PropagateLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "PuffLoader" ? (
        <PuffLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "PulseLoader" ? (
        <PulseLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "RingLoader" ? (
        <RingLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "RiseLoader" ? (
        <RiseLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "RotateLoader" ? (
        <RotateLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "ScaleLoader" ? (
        <ScaleLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "SkewLoader" ? (
        <SkewLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "SquareLoader" ? (
        <SquareLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "SyncLoader" ? (
        <SyncLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : loaderTypeDoc?.activeLoader === "BeatLoader" ? (
        <BeatLoader color={"var(--logo-primary-color)"} loading={true} />
      ) : null}
    </div>
  );
};

export default PGLoaders;
